/**
 * Reviews Page Animations
 * Vanilla JavaScript for Shopify Liquid templates
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initAnimatedCounter();
    initFAQAccordion();
    initScrollAnimations();
    initStarPulse();
  }

  /**
   * Animated Counter for Review Count
   * Animates from 0 to target number when visible
   */
  function initAnimatedCounter() {
    var counters = document.querySelectorAll('[data-animate-count]');
    
    counters.forEach(function(counter) {
      var target = parseInt(counter.getAttribute('data-animate-count'), 10) || 470;
      var duration = parseInt(counter.getAttribute('data-duration'), 10) || 2000;
      var hasAnimated = false;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !hasAnimated) {
            hasAnimated = true;
            animateValue(counter, 0, target, duration);
          }
        });
      }, { threshold: 0.3 });

      observer.observe(counter);
    });
  }

  function animateValue(element, start, end, duration) {
    var startTimestamp = null;
    var suffix = element.getAttribute('data-suffix') || '+';

    function step(timestamp) {
      if (!startTimestamp) startTimestamp = timestamp;
      var progress = Math.min((timestamp - startTimestamp) / duration, 1);
      var easeProgress = easeOutExpo(progress);
      var current = Math.floor(easeProgress * (end - start) + start);
      element.textContent = current + suffix;
      
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  function easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  }

  /**
   * FAQ Accordion Toggle
   * Handles open/close functionality for FAQ items
   */
  function initFAQAccordion() {
    var faqItems = document.querySelectorAll('.reviews-faq__item');
    
    faqItems.forEach(function(item) {
      var question = item.querySelector('.reviews-faq__question');
      var answer = item.querySelector('.reviews-faq__answer');
      var icon = item.querySelector('.reviews-faq__icon');
      
      if (question && answer) {
        question.addEventListener('click', function() {
          var isOpen = item.classList.contains('is-open');
          
          // Close all other items
          faqItems.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('is-open');
              var otherAnswer = otherItem.querySelector('.reviews-faq__answer');
              var otherIcon = otherItem.querySelector('.reviews-faq__icon');
              if (otherAnswer) otherAnswer.style.maxHeight = '0';
              if (otherIcon) otherIcon.style.transform = 'rotate(0deg)';
            }
          });
          
          // Toggle current item
          if (isOpen) {
            item.classList.remove('is-open');
            answer.style.maxHeight = '0';
            if (icon) icon.style.transform = 'rotate(0deg)';
          } else {
            item.classList.add('is-open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            if (icon) icon.style.transform = 'rotate(180deg)';
          }
        });
      }
    });
  }

  /**
   * Scroll-triggered Fade-in Animations
   * Elements with data-animate="fade-in" animate when scrolled into view
   */
  function initScrollAnimations() {
    var animateElements = document.querySelectorAll('[data-animate]');
    
    if (!animateElements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var animationType = entry.target.getAttribute('data-animate');
          var delay = entry.target.getAttribute('data-delay') || 0;
          
          setTimeout(function() {
            entry.target.classList.add('animate-' + animationType);
            entry.target.classList.add('is-visible');
          }, parseInt(delay, 10));
          
          observer.unobserve(entry.target);
        }
      });
    }, { 
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animateElements.forEach(function(el) {
      el.classList.add('animate-hidden');
      observer.observe(el);
    });
  }

  /**
   * Star Pulse Animation
   * Adds staggered pulse animation to star icons
   */
  function initStarPulse() {
    var starGroups = document.querySelectorAll('.reviews-hero__stars-group');
    
    starGroups.forEach(function(group) {
      var stars = group.querySelectorAll('.reviews-hero__star');
      stars.forEach(function(star, index) {
        star.style.animationDelay = (index * 0.25) + 's';
      });
    });
  }

  /**
   * Q&A Form Toggle
   */
  function initQAForm() {
    var askButton = document.querySelector('.reviews-qa__ask-button');
    var form = document.querySelector('.reviews-qa__form');
    var closeButton = document.querySelector('.reviews-qa__form-close');
    
    if (askButton && form) {
      askButton.addEventListener('click', function() {
        form.classList.toggle('is-visible');
        form.style.display = form.classList.contains('is-visible') ? 'block' : 'none';
      });
      
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          form.classList.remove('is-visible');
          form.style.display = 'none';
        });
      }
    }
  }

  // Initialize Q&A form
  initQAForm();

})();
